import { Auth, signInAnonymously } from "firebase/auth"

import { LoadingService } from "react-ui-components/components/LoadingService"

export async function tryAnonymousLogin(authInstance: Auth) {
  LoadingService.setLoading(true)
  try {
    await signInAnonymously(authInstance)
  } catch (error: any) {
    LoadingService.setLoading(true, error?.message || error, true)
    throw error
  } finally {
    LoadingService.setLoading(false)
  }
}

